import { Observable } from 'rxjs';
import { PaymentMeans } from '~client/model/payment-means';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';

export const deletePaymentMethod = rxTask<string, PaymentMeans[]>(
  (paymentMethodId: string): Observable<PaymentMeans[]> =>
    apiClient.paymentController.deletePaymentMethod$(paymentMethodId),
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/interactor/payment/delete-payment-method.ts